/**
 * Wraps the input number around the provided range
 * Input that is too high will be wrapped to the start of the range
 * Input that is too low will be wrapped to the end of the range
 * @param {number} num to wrap
 * @param {number} max of range
 * @param {number} [min=0] of range
 * @returns {number}
 */
export const wrapNumber = (num: number, max: number, min: number = 0): number =>
  ((num - min) % (max - min)) + min;
